import { Pipe, PipeTransform } from '@angular/core';
import { TabloCustomGraphicConfig } from '@ui/tablo-generator/types';

const toDropShadowFilter = (boxShadow: string): string =>
  boxShadow
    // split the individual shadows
    .split(',')
    .map((part) => {
      // tokenise & normalise whitespace
      const tokens = part.trim().split(/\s+/).filter(Boolean);

      // strip out the optional “inset” keyword
      const insetIndex = tokens.indexOf('inset');
      if (insetIndex !== -1) {
        tokens.splice(insetIndex, 1);
      }

      // pull out a colour token if present (hex, rgb[a], hsl[a]…)
      let color = '';
      const colorIndex = tokens.findIndex((t) =>
        /^#|^rgb[a]?|^hsl[a]?/i.test(t),
      );
      if (colorIndex !== -1) {
        color = tokens.splice(colorIndex, 1)[0]; // remove from tokens
      }

      // the remaining length tokens are: offset-x, offset-y, blur, *spread*
      // we keep the first three and drop any spread radius
      const [offsetX = '0', offsetY = '0', blur = '0'] = tokens;

      // rebuild as drop-shadow()
      return `drop-shadow(${[offsetX, offsetY, blur, color]
        .filter(Boolean)
        .join(' ')})`;
    })
    // chain multiple shadows with spaces (filters are space-separated)
    .join(' ');
@Pipe({
    name: 'customGraphicsParentCss',
    standalone: false
})
export class CustomGraphicsParentCssPipe implements PipeTransform {
  transform(item: { config: TabloCustomGraphicConfig }): Record<any, any> {
    const styles: Record<any, any> = {
      'width.px': item.config.width,
      'height.px': item.config.height,
      top: 0,
      left: 0,
      transform: item.config.transform,
      'z-index': item.config.index,
      opacity: item.config.hidden
        ? 0
        : item.config.config?.opacity
        ? item.config.config?.opacity
        : 1,
    };
    if (item.config.config?.hasShadow) {
      styles.filter = toDropShadowFilter(item.config.config.cssShadowFilter);
    }
    return styles;
  }
}
